import React from 'react';

const TABS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'progression', label: 'Progression' }
];

const tabClass = (active) =>
  `rounded-md px-4 py-1.5 text-sm font-medium border transition-all duration-200 shrink-0 ${
    active
      ? 'bg-[#2A565E] text-white border-[#2A565E]'
      : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'
  }`;

const ManagementHeaderTabs = ({ activeTab, onTabChange, tabCounts = {} }) => {
  const getTabLabel = (tab) => {
    const count = tabCounts[tab.key];
    if (count == null) return tab.label;
    return `${tab.label} (${String(count).padStart(2, '0')})`;
  };

  return (
    <div className="flex items-center gap-2">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onTabChange(tab.key)}
          className={tabClass(activeTab === tab.key)}>
          {getTabLabel(tab)}
        </button>
      ))}
    </div>
  );
};

export default ManagementHeaderTabs;
